import React from 'react';
import { QueueStore } from '../store/queue-store';
import { useQueueRegistry } from './use-queue-registry';

export function useRegisterQueueStore(queueStore: QueueStore): void {
    const queueRegistry = useQueueRegistry();
    React.useEffect(() => {
        queueRegistry.addQueueStore(queueStore);
        return () => {
            queueRegistry.removeQueueStore(queueStore);
        };
    }, [queueStore, queueRegistry]);
}
